import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'row nowrap',
      gap: theme.spacing(1),

      '&$allowedSubmit': {
        '& $buttonSubmit': {
          pointerEvents: 'auto',
        },
      },
      alignItems: 'center',
      height: '100%',
    },
    allowedSubmit: {},

    buttonSubmit: {
      padding: theme.spacing(0.75),
      borderRadius: '100%',
      pointerEvents: 'none',
    },
    iconSubmit: {
      color: COLORS.neutral.white,
      transform: 'rotate(-90deg)',

      '& path': {
        strokeWidth: 3,
      },
    },
    divider: {
      height: 28,
      width: 1,
    },
  }),
  { name: 'PromptFooterActions' }
);
